export const vibecodingTranslations = {
  en: {
    hero: {
      title: 'Vibe Coding',
      titleLine2: 'Intensive Course',
      subtitle: 'Create Without Limits',
    },
    backToHome: 'Get Started Today',
    goToDashboard: 'Go to Your Dashboard',
    goToAcademy: 'Go to Academy',
    stats: {
      speed: 'Modules',
      creativity: 'Creative Freedom',
      fun: 'Fun Factor',
    },
    content: {
      title: 'Landing Content',
      description: 'Your Vibe Coding landing content will go here',
    },
    offer: {
      badge: '🔥 Does this sound familiar?',
      pains: [
        "I can't code",
        "No time and money to learn programming", 
        "What's the point? AI platforms replaced IT specialists",
      ],
      truth: {
        title: "The truth no one talks about:",
        text: "AI platforms don't make you free. They make you dependent on their systems, hidden rules, and limitations.",
      },
      rental: {
        text: "With AI platforms, you're not building your own product — you're paying for access and rental. It's like living in a rented apartment.",
      },
      insight: {
        text: "To be developer, you no longer need to know code, you need to understand the system and architecture",
      },
      house_metaphor: {
        text: "AI platforms give you a picture of a house. Developers build the real house.",
      },
      solution: {
        title: "What do you get with Vibe Coding?",
        points: [
          "You decide where it lives and how it grows",
          "You build the architecture and ecosystem of your product",
          "You decide what the design will be",
          "You don't pay constantly for every small change",
          "You understand how your product works and can change it yourself — without fear",
          "You get the profession of the future — AI Product Architect",
          "You become a creator, not just a tool user"
        ],
        tagline: "Even if you are not a coder.",
        ownershipLine1: "AI platforms — that's rent.",
        ownershipLine2: "Vibe Coding — that's ownership.",
      },
      cta: {
        title: "Ready to learn more about Vibe Coding?",
        button: "Get Details",
      },
      author: {
        title: "About author",
        subtitle: "Who am I — and why should you trust me?",
        name: "Anastasia",
        intro: "Hi, my name is",
        bio1: "Two years ago, I became a co-founder of",
        bio1Company: "DESTA",
        bio1End: "— a development team — with zero programming knowledge.",
        bio2: "Initially, my role was generating ideas and communicating with clients while experienced developers turned them into code. But with the rise of AI, everything changed — now I create real digital products myself.",
        bio3: "Today, I'm ready to share this experience with those who dream of building their own products without spending years learning to code.",
        bio4: "",
        bio5: "DESTA Vibe Coding was born from this journey.",
      },
      course: {
        title: "About Course",
        p1: "In this intensive course, I teach you",
        p1Bold: "how to think like a product architect",
        p1End: ". You'll learn how to create your first digital product even if you have zero coding knowledge.",
        p2: "I share the foundation and system-based approach I learned from experienced developers, combined with my own real path of building products with AI.",
        p3: "You'll learn how to design, structure, and most importantly — how to create your own products instead of depending on limited third-party platforms.",
        cta: "If you're ready to create your own website or mobile app, click",
        ctaButton: "Get Started",
        ctaEnd: ", and I'll see you inside the Vibe Coding intensive 🚀",
      },
      program: {
        title: "✨ Vibe Coding — Intensive Course",
        subtitle: "Build your first digital product with AI",
        days: [
          {
            day: "Day 1",
            title: "How Digital Products Actually Work",
            learns: [
              "what every digital product consists of",
              "why tools don't matter without understanding the system",
              "the difference between AI platforms and real product ownership"
            ],
            result: "You see the full picture, not just interfaces."
          },
          {
            day: "Day 2",
            title: "Your First Tech Setup (Without Overwhelm)",
            learns: [
              "what a tech stack really is (in simple terms)",
              "how humans and AI work together in product creation",
              "how to set up a beginner-friendly environment"
            ],
            result: "You're ready to work with AI confidently, not blindly."
          },
          {
            day: "Day 3",
            title: "Building Your First Mini Product",
            learns: [
              "create a simple landing page",
              "design a real interface",
              "add a functional button",
              "learn how to communicate with AI effectively"
            ],
            result: "Your first working digital product — built by you."
          },
          {
            day: "Day 4",
            title: "Product Architecture Made Simple",
            learns: [
              "UI → Logic → Data",
              "how actions turn into results",
              "how products stay flexible and scalable"
            ],
            result: "You gain a mental map that works for any website or app."
          },
          {
            day: "Day 5",
            title: "From Experiment to Real Product",
            learns: [
              "what separates experiments from real products",
              "how product architects think",
              "what the next step looks like if you want to go deeper"
            ],
            result: "A clear path forward — without chaos or guesswork."
          }
        ],
        youllLearn: "You'll learn:",
        youll: "You'll:",
        youllUnderstand: "You'll understand:",
        resultLabel: "👉 Result:"
      },
      faq: {
        title: "❓ FAQ — Vibe Coding Intensive Course",
        items: [
          {
            question: "Do I need any coding experience?",
            answer: "No. This intensive is designed for people with zero coding knowledge. Everything is explained in simple, human language."
          },
          {
            question: "Is this just another AI tools or prompt course?",
            answer: "No. This is not about tools or prompts. You'll learn the foundation of digital products and how to think like a product architect while working with AI."
          },
          {
            question: "What will I actually build during the intensive?",
            answer: "You'll create your first mini digital product: a simple landing page, real structure and logic, built together with AI. The focus is understanding, not complexity."
          },
          {
            question: "How much time do I need each day?",
            answer: "About 1–2 hours per day. Short lessons, clear explanations, and practical steps you can apply immediately."
          },
          {
            question: "Do I need to buy expensive tools or software?",
            answer: "No. You'll learn how to start with minimal setup, minimal costs, and beginner-friendly tools. This intensive is designed to be accessible."
          },
          {
            question: "Why does this intensive cost only $17?",
            answer: "Because it's an entry point, not the full program. It helps you: experience Vibe Coding, understand the approach, and decide if you want to go deeper."
          },
          {
            question: "Is this a replacement for the full Vibe Coding course?",
            answer: "No. This intensive gives you the foundation and clarity. The full course goes deeper into architecture, real products, and launches."
          }
        ]
      },
    },
  },
  uk: {
    hero: {
      title: 'Vibe Coding',
      titleLine2: 'Інтенсив-курс',
      subtitle: 'Створюйте без обмежень',
    },
    backToHome: 'Почати сьогодні',
    goToDashboard: 'Перейти в кабінет',
    goToAcademy: 'Перейти в Академію',
    stats: {
      speed: 'Модулів',
      creativity: 'Свобода творчості',
      fun: 'Фактор задоволення',
    },
    content: {
      title: 'Контент лендінгу',
      description: 'Тут буде контент вашого лендінгу Vibe Coding',
    },
    offer: {
      badge: '🔥 Знайомо?',
      pains: [
        "Не вмію програмувати",
        "Немає часу і грошей вчитися на програміста", 
        "А навіщо? AI платформи замінили IT спеціалістів",
      ],
      truth: {
        title: "Правда, про яку ніхто не говорить:",
        text: "AI-платформи не роблять тебе вільним. Вони роблять тебе залежним від їхніх систем, прихованих правил та обмежень.",
      },
      rental: {
        text: "З AI платформами ти не будуєш свій власний продукт, ти платиш за доступ і оренду. Це як жити в орендованій квартирі.",
      },

      insight: {
        text: "Щоб бути розробником, тобі вже не потрібно знати код, потрібно розуміти систему та архітектуру",
      },
      house_metaphor: {
        text: "AI-платформи дають тобі картинку будинку. Розробники будують справжній будинок.",
      },
      solution: {
        title: "Що ти отримуєш з Vibe Coding?",
        points: [
          "Ти вирішуєш, де він знаходиться і як він буде розвиватися",
          "Ти будуєш архітектуру і екосистему свого продукту",
          "Ти вирішуєш, який буде дизайн",
          "Ти не платиш постійно за кожну дрібну зміну",
          "Ти розумієш, як працює твій продукт, і можеш змінювати його самостійно — без страху",
          "Ти отримуєш професію майбутнього — AI Product Architect",
          "Ти стаєш creator, а не просто користувачем інструментів"
        ],
        tagline: "Навіть якщо ти не програміст.",
        ownershipLine1: "AI-платформи — це оренда.",
        ownershipLine2: "Vibe Coding — це власність.",
      },
      cta: {
        title: "Готові дізнатися більше про Vibe Coding?",
        button: "Отримати деталі",
      },
      author: {
        title: "Про автора",
        subtitle: "Хто я — і чому мені можна довіряти?",
        name: "Анастасія",
        intro: "Привіт, мене звати",
        bio1: "Два роки тому я стала співзасновницею",
        bio1Company: "DESTA",
        bio1End: "— команди розробників — не маючи жодних знань у програмуванні.",
        bio2: "Спочатку моя роль була генерувати ідеї та спілкуватись з клієнтами, поки досвідчені розробники втілювали їх у код. Але з появою AI все змінилося — тепер я сама створюю реальні цифрові продукти.",
        bio3: "Сьогодні я готова поділитися цим досвідом з тими, хто мріє будувати власні продукти, не витрачаючи роки на вивчення програмування.",
        bio4: "",
        bio5: "DESTA Vibe Coding народився саме з цього шляху.",
      },
      course: {
        title: "Про курс",
        p1: "У цьому інтенсивному курсі я вчу",
        p1Bold: "мислити як продуктовий архітектор",
        p1End: ". Ти дізнаєшся, як створити свій перший цифровий продукт, навіть якщо у тебе нульові знання програмування.",
        p2: "Я ділюся фундаментом і системним підходом, який перейняла у досвідчених розробників, а також власним реальним шляхом створення продуктів з AI.",
        p3: "Ти дізнаєшся, як проєктувати, структурувати, і найголовніше — як створювати власні продукти замість того, щоб залежати від обмежених сторонніх платформ.",
        cta: "Якщо ти готовий / готова створити свій вебсайт або мобільний застосунок, натискай",
        ctaButton: "Get Started",
        ctaEnd: ", і побачимось всередині інтенсиву Vibe Coding 🚀",
      },
      program: {
        title: "✨ Vibe Coding — Інтенсив-курс",
        subtitle: "Створи свій перший цифровий продукт з AI",
        days: [
          {
            day: "День 1",
            title: "Як насправді працюють цифрові продукти",
            learns: [
              "з чого складається кожен цифровий продукт",
              "чому інструменти не мають значення без розуміння системи",
              "різниця між AI-платформами та реальним володінням продуктом"
            ],
            result: "Ти бачиш повну картину, а не лише інтерфейси."
          },
          {
            day: "День 2",
            title: "Твоє перше технічне налаштування (без стресу)",
            learns: [
              "що таке tech stack насправді (простими словами)",
              "як люди та AI працюють разом над створенням продукту",
              "як налаштувати середовище для початківців"
            ],
            result: "Ти готовий працювати з AI впевнено, а не наосліп."
          },
          {
            day: "День 3",
            title: "Створення твого першого міні-продукту",
            learns: [
              "створити просту лендінг-сторінку",
              "розробити реальний інтерфейс",
              "додати функціональну кнопку",
              "навчитися ефективно комунікувати з AI"
            ],
            result: "Твій перший працюючий цифровий продукт — створений тобою."
          },
          {
            day: "День 4",
            title: "Архітектура продукту простими словами",
            learns: [
              "UI → Логіка → Дані",
              "як дії перетворюються на результати",
              "як продукти залишаються гнучкими та масштабованими"
            ],
            result: "Ти отримуєш ментальну карту, яка працює для будь-якого сайту чи застосунку."
          },
          {
            day: "День 5",
            title: "Від експерименту до реального продукту",
            learns: [
              "що відрізняє експерименти від реальних продуктів",
              "як думають продуктові архітектори",
              "який наступний крок, якщо хочеш заглибитися"
            ],
            result: "Чіткий шлях вперед — без хаосу та здогадок."
          }
        ],
        youllLearn: "Ти дізнаєшся:",
        youll: "Ти:",
        youllUnderstand: "Ти зрозумієш:",
        resultLabel: "👉 Результат:"
      },
      faq: {
        title: "❓ FAQ — Vibe Coding Інтенсив-курс",
        items: [
          {
            question: "Чи потрібен мені досвід програмування?",
            answer: "Ні. Цей інтенсив розроблений для людей з нульовими знаннями програмування. Все пояснюється простою, людською мовою."
          },
          {
            question: "Це черговий курс про AI інструменти чи промпти?",
            answer: "Ні. Це не про інструменти чи промпти. Ти вивчиш основи цифрових продуктів і як думати як архітектор продукту, працюючи з AI."
          },
          {
            question: "Що я реально створю під час інтенсиву?",
            answer: "Ти створиш свій перший міні-цифровий продукт: простий лендінг, реальну структуру та логіку, побудований разом з AI. Фокус на розумінні, а не на складності."
          },
          {
            question: "Скільки часу мені потрібно кожного дня?",
            answer: "Приблизно 1–2 години на день. Короткі уроки, чіткі пояснення та практичні кроки, які можна застосувати відразу."
          },
          {
            question: "Чи потрібно купувати дорогі інструменти чи програми?",
            answer: "Ні. Ти навчишся, як почати з мінімальним налаштуванням, мінімальними витратами та інструментами для початківців. Цей інтенсив розроблений, щоб бути доступним."
          },
          {
            question: "Чому цей інтенсив коштує лише $17?",
            answer: "Тому що це точка входу, а не повна програма. Він допоможе тобі: відчути Vibe Coding, зрозуміти підхід та вирішити, чи хочеш ти піти глибше."
          },
          {
            question: "Це заміна повного курсу Vibe Coding?",
            answer: "Ні. Цей інтенсив дає тобі основу та ясність. Повний курс йде глибше в архітектуру, реальні продукти та запуски."
          }
        ]
      },
    },
  },
} as const;